export default "__VITE_ASSET__OGqIjYEc__"